import {
    type FC
} from "react";
import {
    View
} from "react-native";
import type ITreeViewPlaceholderProps from "./type";
import stylesheet, {
    useStyles
} from "./stylesheet";
import {
    NCoreUIKitLocalize,
    NCoreUIKitTheme
} from "../../../../core/hooks";
import {
    useTreeViewContext
} from "../../context";
import {
    TREE_VIEW_PLACEHOLDER_WIDTHS
} from "../../util";
import Skeleton from "../../../skeleton";
import Text from "../../../text";

const TreeViewPlaceholder: FC<ITreeViewPlaceholderProps> = ({
    count = 0,
    kind,
    level
}) => {
    const {
        customLocalize,
        customTheme,
        measures
    } = useTreeViewContext();

    const {
        colors
    } = NCoreUIKitTheme.useContext(customTheme);

    const {
        localize
    } = NCoreUIKitLocalize.useContext(customLocalize);

    const {
        row: rowDynamicStyle
    } = useStyles({
        measures,
        level
    });

    if(kind === "note") {
        return <View
            style={[
                stylesheet.row,
                rowDynamicStyle
            ]}
        >
            <Text
                customColor={colors.content.text.low}
                variant={measures.labelVariant}
                customTheme={customTheme}
                numberOfLines={1}
            >
                {localize("tree-view-empty-branch")}
            </Text>
        </View>;
    }

    return <View
        aria-hidden={true}
    >
        {
            Array.from({
                length: count
            }, (_, index) => <View
                style={[
                    stylesheet.row,
                    rowDynamicStyle
                ]}
                key={index}
            >
                <Skeleton
                    customTheme={customTheme}
                    size={measures.iconSize}
                    variant="icon"
                />
                <Skeleton
                    width={TREE_VIEW_PLACEHOLDER_WIDTHS[index % TREE_VIEW_PLACEHOLDER_WIDTHS.length]}
                    typography={measures.labelVariant}
                    customTheme={customTheme}
                    variant="text"
                />
            </View>)
        }
    </View>;
};
export default TreeViewPlaceholder;
